var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.498 2.3331H6.99911C6.38034 2.3331 5.7869 2.57891 5.34936 3.01645C4.91182 3.45399 4.66602 4.04742 4.66602 4.6662V23.331C4.66602 23.9497 4.91182 24.5432 5.34936 24.9807C5.7869 25.4183 6.38034 25.6641 6.99911 25.6641H20.9977C21.6165 25.6641 22.2099 25.4183 22.6474 24.9807C23.085 24.5432 23.3308 23.9497 23.3308 23.331V8.16584L17.498 2.3331Z",
    stroke: "white",
    strokeWidth: 2.3331,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.332 2.3331V6.99929C16.332 7.61807 16.5778 8.2115 17.0154 8.64904C17.4529 9.08658 18.0464 9.33239 18.6651 9.33239H23.3313",
    stroke: "white",
    strokeWidth: 2.3331,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6651 10.4989H9.33203",
    stroke: "white",
    strokeWidth: 2.3331,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6644 15.1651H9.33203",
    stroke: "white",
    strokeWidth: 2.3331,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6644 19.8313H9.33203",
    stroke: "white",
    strokeWidth: 2.3331,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon12);
export default __webpack_public_path__ + "static/media/icon12.150b45b53bb7f7985f55fe1187f6f48d.svg";
export { ForwardRef as ReactComponent };